import React, { useEffect, useRef } from 'react';

function FavoriteSlotsBar({ Plot, data }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (
      !Plot ||
      typeof Plot.plot !== 'function' ||
      typeof Plot.barY !== 'function' ||
      !containerRef.current ||
      !data?.length
    ) {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
      return;
    }

    const container = containerRef.current;
    container.innerHTML = '';

    const chart = Plot.plot({
      width: 600,
      height: 600,
      style: { background: 'white', fontSize: 16 },
      marginBottom: 160,
      marginLeft: 40,

      x: {
        label: 'Slot Machine',
        domain: data.map((d) => d.slot),
        tickRotate: -35,
        tickPadding: 6,
      },
      y: {
        label: 'Occurrences',
        grid: true,
        labelOffset: 60,
      },
      marks: [
        Plot.barY(data, {
          x: 'slot',
          y: 'count',
          fill: '#76ace0',
          title: (d) => `${d.slot}: ${d.count} occurrences`,
        }),
      ],
    });

    container.appendChild(chart);

    return () => {
      if (chart && chart.remove) {
        chart.remove();
      }
    };
  }, [Plot, data]);

  return (
    <div className="chart-container">
      <h2 style={{ fontSize: '16px' }}>FAVORITE SLOTS (TIMES PLAYED)</h2>
      <div ref={containerRef} />
    </div>
  );
}

export default FavoriteSlotsBar;
